<script>
import Loader from "@/components/widgets/loader";
import Layout from "../../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";

import {getCrossPosition, getCrossBalance, getEquityAll, getCrossFunding, getCrossEquity, getStrategyRet, getProfitData, getChargeData, getMonthProfitData} from '@/api/user'

/**
 * Starter component
 */
export default {
  page: {
    title: "账户概览",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: { Layout, PageHeader},
  props: {
    updating1: {
      type: Boolean,
    },
    updating2: {
      type: Boolean,
    },
  },
  data() {
    return {
      items: [
        {
          text: "Utility",
          href: "/"
        },
        {
          text: "Starter Page",
          active: true
        }
      ],
      show_base: "本金",
      show_withdraw: "近30天充提",
      show_latest: "最新净值",
      show_profit7: "7天收益",
      show_profit30: "30天收益",
      show_profit_total: "累计收益",
      show_rate7: "7日年化收益",
      show_rate30: "30日年化收益",
      show_rate_total: "累计年化收益",
      show_volume: "当日交易量",
      show_volume7: "日均交易量(7天)",
      show_leverage: "总杠杆率",
      username: "",
      account: '',
      alias: '',
      baseEquity: 0,
      latestEquity: 0,
      totalWithdraw: 0,
      weekRet: 0,
      MonthRet: 0,
      YearRet: 0,
      weekAmount: 0,
      MonthAmount: 0,
      YearAmount: 0,
      fundingList: [],
      weighted_hist_funding: 0,
      weighted_realtime_funding: 0,
      title: "账户概览",
      equity_list: [],
      position_list: [],
      balance_list: [],
      A_list: [],
      B_list: [],
      C_list: [],
      isAdmin: 0,
      isFake: 0,
      isBTC: 0,
      latest_volume: 0,
      av_volume: 0,
      ratio: 0,
      is_zhengyi: 0,
      
      charge_list: [],
      profit_totalRows: 1,
      profit_currentPage: 1,
      profit_perPage: 10,
      profit_pageOptions: [10, 25, 50, 100],
      profit_filter: "",
      profit_filterOn: [],
      profit_sortBy: "-date",
      profit_sortDesc: false,
      profit_count: 0,
      profitData: [],
      profitfields: [
        {
          key: "alias",
          sortable: true
        },
        {
          key: "date",
          sortable: true
        },
        {
          key: "pnl",
          sortable: true
        },
        {
          key: "coin",
          sortable: true
        },
      ],

      month_totalRows: 1,
      month_currentPage: 1,
      month_perPage: 10,
      month_pageOptions: [10, 25, 50, 100],
      month_filter: "",
      month_filterOn: [],
      month_sortBy: "-month",
      month_sortDesc: false,
      month_count: 0,
      monthData: [],
      monthfields: [
        {
          key: "month",
          sortable: true
        },
        {
          key: "yield",
          sortable: true
        }
      ],

      chargefields: [
        {
          key: "alias",
          sortable: true
        },
        {
          key: "date",
          sortable: true
        },
        {
          key: "operation",
          sortable: true
        },
        {
          key: "amount",
          sortable: true
        },
        {
          key: "coin",
          sortable: true
        },
      ],

      equity_fields: [
        {
          key: "exchange",
          sortable: true
        },
        {
          key: "equity_usdt",
          sortable: true
        },
        {
          key: "position_value_usdt",
          sortable: true
        },
        {
          key: "long_pv",
          sortable: true
        },
        {
          key: "short_pv",
          sortable: true
        },
        {
          key: "liquidate_ratio",
          sortable: true
        },
        {
          key: "equity/position",
          sortable: true
        }
      ],
      position_fields: [
        {
          key: "exchange",
          sortable: true
        },
        {
          key: "symbol",
          sortable: true
        },
        {
          key: "position_type",
          sortable: true
        },
        {
          key: "quantity",
          sortable: true
        },
        {
          key: "open_price",
          sortable: true
        },
        // {
        //   key: "avg_price",
        //   sortable: true
        // },
        {
          key: "curren_price",
          sortable: true
        },
        {
          key: "estimated_liquidation_price",
          sortable: true
        },
        {
          key: "ADL",
          sortable: true
        },
        {
          key: "leverage",
          sortable: true
        },
        {
          key: "position_value",
          sortable: true
        }
      ],
      balance_fields: [
        {
          key: "exchange",
          sortable: true
        },
        {
          key: "coin",
          sortable: true
        },
        {
          key: "amount_free",
          sortable: true
        },
        {
          key: "amount_total",
          sortable: true
        },
        {
          key: "total_usd_value",
          sortable: true
        },
        {
          key: "total_usdt_value",
          sortable: true
        }
      ],
      A_fields: [
        {
          key: "coin",
          sortable: true
        },
        {
          key: "predicted_rate",
          sortable: true
        },
        {
          key: "last_rate",
          sortable: true
        },
        {
          key: "1day",
          sortable: true
        },
        {
          key: "3day",
          sortable: true
        },
        {
          key: "7day",
          sortable: true
        },
        // {
        //   key: "hour_basis",
        //   sortable: true
        // },
        // {
        //   key: "week_basis",
        //   sortable: true
        // },
      ],
      B_fields: [
        {
          key: "exchange",
          sortable: true
        },
        {
          key: "weight_rate",
          sortable: true
        }
      ],
      C_fields: [
        {
          key: "coin",
          sortable: true
        },
        {
          key: "position_value",
          sortable: true
        },
        {
          key: "predicted_rate",
          sortable: true
        },
        {
          key: "predicted_profit",
          sortable: true
        },
        {
          key: "1day_profit",
          sortable: true
        },
        {
          key: "3day_profit",
          sortable: true
        },
        {
          key: "7day_profit",
          sortable: true
        }
      ],
      perPage: 100,
      currentPage: 1,
      usdt_equityoption: {
        backgroundColor: '#2A3042',
        title: {
          text: '',
          left: 'center'
        },
        toolbox: {
          feature: {
            dataZoom: {
              yAxisIndex: false
            },
            saveAsImage: {
              pixelRatio: 2
            }
          }
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          }
        },
        grid: {
          bottom: 90
        },
        dataZoom: [
          {
            type: 'inside'
          },
          {
            type: 'slider'
          }
        ],
        xAxis: {
          data: [],
          silent: false,
          splitLine: {
            show: false
          },
          splitArea: {
            show: false
          }
        },
        yAxis: {
          type: 'value',
          scale:true,
          splitArea: {
            show: false
          }
        },
        series: [
          {
            type: 'line',
            data: [],
            // Set `large` for large data amount
            large: true
          }
        ]
      },
      usd_equityoption: {
        backgroundColor: '#2A3042',
        title: {
          text: '',
          left: 'center'
        },
        toolbox: {
          feature: {
            dataZoom: {
              yAxisIndex: false
            },
            saveAsImage: {
              pixelRatio: 2
            }
          }
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          }
        },
        grid: {
          bottom: 90
        },
        dataZoom: [
          {
            type: 'inside'
          },
          {
            type: 'slider'
          }
        ],
        xAxis: {
          data: [],
          silent: false,
          splitLine: {
            show: false
          },
          splitArea: {
            show: false
          }
        },
        yAxis: {
          type: 'value',
          scale:true,
          splitArea: {
            show: false
          }
        },
        series: [
          {
            type: 'line',
            data: [],
            // Set `large` for large data amount
            large: true
          }
        ]
      },
    };
  },
  methods: {
    onResize(e) {
      this.usdt_equityChart_ = this.$echarts.init(document.getElementById('usdt_equityChart'),'dark')
      this.usdt_equityChart_.resize()

      if (this.isAdmin > 0&&this.isFake==0) {
        this.usd_equityChart_ = this.$echarts.init(document.getElementById('usd_equityChart'),'dark')
        this.usd_equityChart_.resize()
      }
    },
    profit_data() {
      let promise = getProfitData(this.alias, this.profit_perPage, this.profit_currentPage-1); return promise.then(res => {
        this.profit_count = res["count"]
        // this.trade_currentPage = res["offset"] + 1
        console.log(this.profit_currentPage)
        return res["data"]
      }).catch(error => {
        console.log(error)
      })
    },
    month_data() {
      let promise = getMonthProfitData(this.alias, this.month_perPage, this.month_currentPage-1); return promise.then(res => {
        this.month_count = res["count"]
        // this.trade_currentPage = res["offset"] + 1
        console.log(this.month_currentPage)
        return res["data"]
      }).catch(error => {
        console.log(error)
      })
    },
    get_charge_data() {
      let promise = getChargeData(this.alias); return promise.then(res => {
        this.charge_list = res
      }).catch(error => {
        console.log(error)
      })
    },
    getEquityRet() {
      var alias_usd = this.alias + "_usdt"
      getStrategyRet(alias_usd).then((res) => {
        console.log('get rett')
        console.log(res)
        this.weekAmount = res[0]['amount']
        this.weekRet = res[0]['apr']

        this.MonthAmount = res[1]['amount']
        this.MonthRet = res[1]['apr']

        this.YearAmount = res[2]['amount']
        this.YearRet = res[2]['apr']

        this.baseEquity = res[3]
        this.latestEquity = res[4]
        this.totalWithdraw = res[5]
        this.latest_volume = res[6]
        this.av_volume = res[7]
        this.ratio = res[8]

      }).catch((error) => {
        console.log(error)
      })
    },
    get_equity_list() {
      getCrossEquity(this.alias).then(res => {
        console.log(res)
        this.equity_list = res
      }).catch(error => {
        console.log(error)
      })
    },
    get_positon_list() {
      getCrossPosition(this.alias).then(res => {
        console.log(res)
        this.position_list = res[0]
      }).catch(error => {
        console.log(error)
      })
    },
    get_balance_list() {
      getCrossBalance(this.alias).then(res => {
        console.log(res)
        this.balance_fields = []
        let fields = res[0]
        if (Object.keys(res[0]).length < Object.keys(res[res.length-1]).length) {
          fields = res[res.length-1]
        }
        for(var key in fields){
          this.balance_fields.push(
            {
              "key": key,
              "sortable": true
            }
          )
        }
        this.balance_list = res
      }).catch(error => {
        console.log(error)
      })
    },
    get_list() {
      getCrossFunding(this.alias).then(res => {
        console.log(res)
        let coin_list = res[2]
        this.C_fields = []
        for(var key in coin_list[0]){
          this.C_fields.push(
            {
              "key": key,
              "sortable": true
            }
          )
        }
        this.A_list = res[1]
        // this.B_list = res[2]
        this.C_list = coin_list
      }).catch(error => {
        console.log(error)
      })
    },
    chect_data() {
      this.getEquityRet()
      this.get_equity_list()
      this.get_list()
      this.get_positon_list()
      this.get_balance_list()
    },
    showEquityChart_usdt() {
      var alias_usdt = this.alias + "_usdt"
      getEquityAll(alias_usdt).then((res) => {
      this.equityChart_ = this.$echarts.init(document.getElementById('usdt_equityChart'),'dark')

      this.equitydata = []
      this.equitydate = []

      for (let i = 0; i < res.length; ++i) {
        this.equitydata.push(parseFloat(res[i]['totalEquity']))
        this.equitydate.push(res[i]['timestamp'])
      }

      // console.log('equitydata')
      // console.log(this.equitydata)

      this.usdt_equityoption.xAxis.data = this.equitydate
      this.usdt_equityoption.series[0].data = this.equitydata
      this.usdt_equityoption.title.text = "PnL USDT"
      if (this.alias.includes("btc")){
        this.usdt_equityoption.title.text = "PnL BTC"
      }

      this.equityChart_.setOption(this.usdt_equityoption)
      }).catch((error) => {
        console.log(error)
      })
    },
    showEquityChart_usd() {
      var alias_usd = this.alias + "_usd"
      getEquityAll(alias_usd).then((res) => {
      this.equityChart_ = this.$echarts.init(document.getElementById('usd_equityChart'),'dark')

      this.equitydata = []
      this.equitydate = []

      for (let i = 0; i < res.length; ++i) {
        this.equitydata.push(parseFloat(res[i]['value']))
        this.equitydate.push(res[i]['timestamp'])
      }

      // console.log('equitydata')
      // console.log(this.equitydata)

      this.usd_equityoption.xAxis.data = this.equitydate
      this.usd_equityoption.series[0].data = this.equitydata
      this.usd_equityoption.title.text = "业绩走势"

      this.equityChart_.setOption(this.usd_equityoption)
      }).catch((error) => {
        console.log(error)
      })
    },
    checkAccount() {
      if (this.$route.query.alias)
      {
        if (this.$route.query.alias != this.alias)
        {
          this.alias = this.$route.query.alias
          this.get_charge_data()
          this.getEquityRet()
          this.showEquityChart_usd()
          if (this.isAdmin>0){ 
            this.get_equity_list()
            this.get_list()
            this.get_balance_list()
            this.showEquityChart_usdt()
          }
          if (this.isAdmin>0||this.is_zhengyi>0){
            this.get_positon_list()
          }
          
        }
      }
    }
  },
  mounted() {
    this.isAdmin = localStorage.getItem("is_admin")
    this.username = localStorage.getItem("username")
    this.alias = this.$route.query.alias
    if (this.username.includes("bacon")){
      this.is_zhengyi= 1
    }
    if (this.alias.includes("prop")){
      this.isFake = 1
    }
    if (this.username.includes("haoyun")){
      this.is_zhengyi = 1
    }
    if (this.alias.includes("zenxpair02")){
      this.isFake = 1
    }
    if (this.alias.includes("btc")){
      this.isBTC = 1
    }

    this.get_charge_data()
    this.getEquityRet()
    this.showEquityChart_usd()
    if (this.isAdmin>0){
      
      this.get_equity_list()
      this.get_list()
      this.get_balance_list()
      this.showEquityChart_usdt()
    }
    if (this.isAdmin>0||this.is_zhengyi>0){
      this.get_positon_list()
    }
    this.my_timer = setInterval(this.checkAccount, 100)
  },
  destroyed(){
            //console.log("销毁-----------------------之后");
        },
  beforeDestroy(){
    clearInterval(this.my_timer)
    //console.log("我要死了啦啦啦啦啦啦绿绿绿绿绿绿绿绿绿绿绿")
  }
};
</script>
<template>
  <Layout>
    <PageHeader
      :title="title"
    />

    <div class="row">

      <div class="col-sm-4">
        <div class="card">
          <div class="card-body">
            <div class="d-flex align-items-center mb-3">
              <div class="avatar-xs mr-3">
                <span
                  class="avatar-title rounded-circle bg-soft-primary text-primary font-size-18"
                >
                  <i class="bx bx-copy-alt" />
                </span>
              </div>
              <h5 class="font-size-14 mb-0">
                {{show_base}}
              </h5>
            </div>
            <div class="text-muted mt-4">
              <h4 >
                {{baseEquity}}
              </h4>
            </div>
          </div>
        </div>
      </div>

      <div class="col-sm-4">
        <div class="card">
          <div class="card-body">
            <div class="d-flex align-items-center mb-3">
              <div class="avatar-xs mr-3">
                <span
                  class="avatar-title rounded-circle bg-soft-primary text-primary font-size-18"
                >
                  <i class="bx bx-copy-alt" />
                </span>
              </div>
              <h5 class="font-size-14 mb-0">
                {{show_withdraw}}
              </h5>
            </div>
            <div class="text-muted mt-4">
              <h4 >
                {{totalWithdraw}}
              </h4>
            </div>
          </div>
        </div>
      </div>

      <div class="col-sm-4">
        <div class="card">
          <div class="card-body">
            <div class="d-flex align-items-center mb-3">
              <div class="avatar-xs mr-3">
                <span
                  class="avatar-title rounded-circle bg-soft-primary text-primary font-size-18"
                >
                  <i class="bx bx-archive-in" />
                </span>
              </div>
              <h5 class="font-size-14 mb-0">
                {{show_latest}}
              </h5>
            </div>
            <div class="text-muted mt-4">
              <h4>
                    {{latestEquity}}
              </h4>
            </div>
          </div>
        </div>
      </div>



      <div class="col-sm-4">
        <div class="card">
          <div class="card-body">
            <div class="d-flex align-items-center mb-3">
              <div class="avatar-xs mr-3">
                <span
                  class="avatar-title rounded-circle bg-soft-primary text-primary font-size-18"
                >
                  <i class="bx bx-copy-alt" />
                </span>
              </div>
              <h5 class="font-size-14 mb-0">
                {{show_profit7}}
              </h5>
            </div>
            <div class="text-muted mt-4">
              <h4 v-if="isBTC==0">
                $ {{weekAmount}}
                <i v-if="weekAmount >= 0" class="mdi mdi-chevron-up ml-1 text-success" />
                <i v-else class="mdi mdi-chevron-down ml-1 text-danger" />
              </h4>
              <h4 v-if="isBTC>0">
                 {{weekAmount}} BTC
                <i v-if="weekAmount >= 0" class="mdi mdi-chevron-up ml-1 text-success" />
                <i v-else class="mdi mdi-chevron-down ml-1 text-danger" />
              </h4>
              <div class="d-flex">
                <span v-if="weekAmount >= 0" class="badge badge-soft-success font-size-12" v-format="'0.##%'">{{weekRet}}</span>
                <span v-else class="badge badge-soft-danger font-size-12" v-format="'0.##%'">{{weekRet}}</span>
                <span class="ml-2 text-truncate">{{show_rate7}}</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-sm-4">
        <div class="card">
          <div class="card-body">
            <div class="d-flex align-items-center mb-3">
              <div class="avatar-xs mr-3">
                <span
                  class="avatar-title rounded-circle bg-soft-primary text-primary font-size-18"
                >
                  <i class="bx bx-archive-in" />
                </span>
              </div>
              <h5 class="font-size-14 mb-0">
                {{show_profit30}}
              </h5>
            </div>
            <div class="text-muted mt-4">
              <h4 v-if="isBTC==0">
                $ {{MonthAmount}}
                <i v-if="MonthAmount >= 0" class="mdi mdi-chevron-up ml-1 text-success" />
                <i v-else class="mdi mdi-chevron-down ml-1 text-danger" />
              </h4>
              <h4 v-if="isBTC>0">
                {{MonthAmount}} BTC
                <i v-if="MonthAmount >= 0" class="mdi mdi-chevron-up ml-1 text-success" />
                <i v-else class="mdi mdi-chevron-down ml-1 text-danger" />
              </h4>
              <div class="d-flex">
                <span v-if="MonthRet >= 0" class="badge badge-soft-success font-size-12" v-format="'0.##%'">{{MonthRet}}</span>
                <span v-else class="badge badge-soft-danger font-size-12" v-format="'0.##%'">{{MonthRet}}</span>
                <span class="ml-2 text-truncate">{{show_rate30}}</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-sm-4">
        <div class="card">
          <div class="card-body">
            <div class="d-flex align-items-center mb-3">
              <div class="avatar-xs mr-3">
                <span
                  class="avatar-title rounded-circle bg-soft-primary text-primary font-size-18"
                >
                  <i class="bx bx-purchase-tag-alt" />
                </span>
              </div>
              <h5 class="font-size-14 mb-0">
                {{show_profit_total}}
              </h5>
            </div>
            <div class="text-muted mt-4">
              <h4 v-if="isBTC==0">
                $ {{YearAmount}}
                <i v-if="YearAmount >= 0" class="mdi mdi-chevron-up ml-1 text-success" />
                <i v-else class="mdi mdi-chevron-down ml-1 text-danger" />
              </h4>
              <h4 v-if="isBTC>0">
                {{YearAmount}} BTC
                <i v-if="YearAmount >= 0" class="mdi mdi-chevron-up ml-1 text-success" />
                <i v-else class="mdi mdi-chevron-down ml-1 text-danger" />
              </h4>

              <div class="d-flex">
                <span v-if="YearRet >= 0" class="badge badge-soft-success font-size-12" v-format="'0.##%'">{{YearRet}}</span>
                <span v-else class="badge badge-soft-danger font-size-12" v-format="'0.##%'">{{YearRet}}</span>
                <span class="ml-2 text-truncate">{{show_rate_total}}</span>
              </div>
            </div>
          </div>
        </div>
      </div>


      <div v-if="isAdmin > 0" class="col-sm-4">
        <div class="card">
          <div class="card-body">
            <div class="d-flex align-items-center mb-3">
              <div class="avatar-xs mr-3">
                <span
                  class="avatar-title rounded-circle bg-soft-primary text-primary font-size-18"
                >
                  <i class="bx bx-archive-in" />
                </span>
              </div>
              <h5 class="font-size-14 mb-0">
                {{show_volume}}
              </h5>
            </div>
            <div class="text-muted mt-4">
              <h4>
                    {{latest_volume}}
              </h4>
            </div>
          </div>
        </div>
      </div>

      <div v-if="isAdmin > 0" class="col-sm-4">
        <div class="card">
          <div class="card-body">
            <div class="d-flex align-items-center mb-3">
              <div class="avatar-xs mr-3">
                <span
                  class="avatar-title rounded-circle bg-soft-primary text-primary font-size-18"
                >
                  <i class="bx bx-archive-in" />
                </span>
              </div>
              <h5 class="font-size-14 mb-0">
                {{show_volume7}}
              </h5>
            </div>
            <div class="text-muted mt-4">
              <h4>
                    {{av_volume}}
              </h4>
            </div>
          </div>
        </div>
      </div>

      <div v-if="isAdmin > 0" class="col-sm-4">
        <div class="card">
          <div class="card-body">
            <div class="d-flex align-items-center mb-3">
              <div class="avatar-xs mr-3">
                <span
                  class="avatar-title rounded-circle bg-soft-primary text-primary font-size-18"
                >
                  <i class="bx bx-archive-in" />
                </span>
              </div>
              <h5 class="font-size-14 mb-0">
                {{show_leverage}}
              </h5>
            </div>
            <div class="text-muted mt-4">
              <h4>
                    {{ ratio}}
              </h4>
            </div>
          </div>
        </div>
      </div>

      


    </div>
    <!-- <div class="row">
      <div class="col-xl-12">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title mb-4">仓位</h4>
            <Loader :loading="updating1">
              <div class="table-responsive mb-0">
                <table class="table table-centered table-nowrap">
                  <thead class="thead-light">
                    <tr>
                      <th>交易所</th>
                      <th>品种</th>
                      <th>方向</th>
                      <th>数量</th>
                      <th>开仓价</th>
                      <th>当前价</th>
                      <th>估计平仓价</th>
                      <th>仓位价值</th>
                    </tr>
                  </thead>

                  <tbody>
                    <tr
                      v-for="pos in position_list"
                      :key="pos.exchange"
                    >
                      <td>{{ pos.exchange }}</td>
                      <td>{{ pos.symbol }}</td>
                      <td>{{ pos.position_type }}</td>
                      <td v-format="'0.0000'">{{ pos.quantity }}</td>
                      <td v-format="'0.0000'">{{ pos.open_price }}</td>
                      <td v-format="'0.0000'">{{ pos.curren_price }}</td>
                      <td v-format="'0.0000'">{{ pos.estimated_liquidation_price }}</td>
                      <td v-format="'0.0000'">{{ pos.position_value }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </Loader>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-xl-12">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title mb-4">资金</h4>
            <Loader :loading="updating2">
              <div class="table-responsive mb-0">
                <table class="table table-centered table-nowrap">
                  <thead class="thead-light">
                    <tr>
                      <th>交易所</th>
                      <th>币种</th>
                      <th>可用资金</th>
                      <th>总资金</th>
                      <th>USD总资金</th>
                      <th>USDT总资金</th>
                    </tr>
                  </thead>

                  <tbody>
                    <tr
                      v-for="balance in balance_list"
                      :key="balance.exchange"
                    >
                      <td>{{ balance.exchange }}</td>
                      <td>{{ balance.coin }}</td>
                      <td v-format="'0.00'">{{ balance.amount_free }}</td>
                      <td v-format="'0.00'">{{ balance.amount_total }}</td>
                      <td v-format="'0.00'">{{ balance.total_usd_value }}</td>
                      <td v-format="'0.00'">{{ balance.total_usdt_value }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </Loader>
          </div>
        </div>
      </div>
    </div> -->

    <div v-if="isAdmin > 0" class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title mb-4">
              Equity
            </h4>
              <!-- Table -->
              <div>
                <b-table
                  hover
                  :items="equity_list"
                  :fields="equity_fields"
                />
              </div>
          </div>
        </div>
      </div>
    </div>

    <div v-if="isAdmin > 0&&isFake==0" class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title mb-4">
              Profit
            </h4>
              <!-- Table -->
              <div>
                <b-table
                  hover
                  :items="C_list"
                  :fields="C_fields"
                />
              </div>
          </div>
        </div>
      </div>
    </div>


    <div v-if="isAdmin > 0||is_zhengyi>0" class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title mb-4">
              仓位
            </h4>
              <!-- Table -->
              <div>
                <b-table
                  hover
                  :items="position_list"
                  :fields="position_fields"
                />
              </div>
          </div>
        </div>
      </div>
    </div>

    <div v-if="isAdmin > 0" class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title mb-4">
              资金
            </h4>
              <!-- Table -->
              <div>
                <b-table
                  hover
                  :items="balance_list"
                  :fields="balance_fields"
                />
              </div>
          </div>
        </div>
      </div>
    </div>

    <div v-if="isAdmin > 0&&isFake==0" class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title mb-4">
              A
            </h4>
              <!-- Table -->
              <div>
                <b-table
                  hover
                  :items="A_list"
                  :fields="A_fields"
                />
              </div>
          </div>
        </div>
      </div>
    </div>

    <!-- <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title mb-4">
              B
            </h4>
              <div>
                <b-table
                  hover
                  :items="B_list"
                  :fields="B_fields"
                />
              </div>
          </div>
        </div>
      </div>
    </div> -->

    <div v-if="isAdmin > 0&&isFake==0" class="row" v-resize @resize="onResize">
      <div class="col-xl-12">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title mb-4">
            规模
            </h4>
            <div id="usdt_equityChart" style="height:400px;"></div>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-xl-12">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title mb-4">
            收益
            </h4>
            <div id="usd_equityChart" style="height:400px;"></div>
          </div>
        </div>
      </div>
    </div>

    <div v-if="username!='zenx03'" class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title mb-4">
              收益明细
            </h4>
            <b-tabs
              content-class="mt-3"
              nav-class="nav-tabs-custom"
            >
              <b-tab
                title="All"
                active
              >
                <div class="row mt-4">
                  <div class="col-sm-12 col-md-6">
                    <div
                      id="tickets-table_length"
                      class="dataTables_length"
                    >
                      <label class="d-inline-flex align-items-center">
                        Show&nbsp;
                        <b-form-select
                          v-model="profit_perPage"
                          size="sm"
                          :options="profit_pageOptions"
                        />&nbsp;entries
                      </label>
                    </div>
                  </div>
                  <!-- Search -->
                  <div class="col-sm-12 col-md-6">
                    <div
                      id="tickets-table_filter"
                      class="dataTables_filter text-md-right"
                    >
                      <label v-if="isAdmin > 10" class="d-inline-flex align-items-center">
                        Search:
                        <b-form-input
                          v-model="alias"
                          type="search"
                          placeholder="Search..."
                          class="form-control form-control-sm ml-2"
                        />
                      </label>
                    </div>
                  </div>
                  <!-- End search -->
                </div>
                <!-- Table -->
                <div class="table-responsive table-hover mb-0">
                  <b-table
                    :items="profit_data"
                    :fields="profitfields"
                    responsive="sm"
                    :per-page="profit_perPage"
                    :current-page="profit_currentPage"
                    :sort-by.sync="profit_sortBy"
                    :sort-desc.sync="profit_sortDesc"
                    :filter="alias"
                    :filter-included-fields="profit_filterOn"
                  />
                </div>
                <div class="row">
                  <div class="col">
                    <div class="dataTables_paginate paging_simple_numbers float-right">
                      <ul class="pagination pagination-rounded mb-0">
                        <!-- pagination -->
                        <b-pagination
                          v-model="profit_currentPage"
                          :total-rows="profit_count"
                          :per-page="profit_perPage"
                          first-number
                          last-number
                        />
                      </ul>
                    </div>
                  </div>
                </div>
              </b-tab>
              <!-- <b-tab title="Buy" disabled> </b-tab>
                        <b-tab title="Sell" disabled> </b-tab> -->
            </b-tabs>
          </div>
        </div>
      </div>
    </div>


    <div v-if="username!='zenx03'" class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title mb-4">
              月收益率
            </h4>
            <b-tabs
              content-class="mt-3"
              nav-class="nav-tabs-custom"
            >
              <b-tab
                title="All"
                active
              >
                <div class="row mt-4">
                  <div class="col-sm-12 col-md-6">
                    <div
                      id="tickets-table_length"
                      class="dataTables_length"
                    >
                      <label class="d-inline-flex align-items-center">
                        Show&nbsp;
                        <b-form-select
                          v-model="month_perPage"
                          size="sm"
                          :options="month_pageOptions"
                        />&nbsp;entries
                      </label>
                    </div>
                  </div>
                  <!-- Search -->
                  <div class="col-sm-12 col-md-6">
                    <div
                      id="tickets-table_filter"
                      class="dataTables_filter text-md-right"
                    >
                      <label v-if="isAdmin > 10" class="d-inline-flex align-items-center">
                        Search:
                        <b-form-input
                          v-model="alias"
                          type="search"
                          placeholder="Search..."
                          class="form-control form-control-sm ml-2"
                        />
                      </label>
                    </div>
                  </div>
                  <!-- End search -->
                </div>
                <!-- Table -->
                <div class="table-responsive table-hover mb-0">
                  <b-table
                    :items="month_data"
                    :fields="monthfields"
                    responsive="sm"
                    :per-page="month_perPage"
                    :current-page="month_currentPage"
                    :sort-by.sync="month_sortBy"
                    :sort-desc.sync="month_sortDesc"
                    :filter="alias"
                    :filter-included-fields="month_filterOn"
                  />
                </div>
                <div class="row">
                  <div class="col">
                    <div class="dataTables_paginate paging_simple_numbers float-right">
                      <ul class="pagination pagination-rounded mb-0">
                        <!-- pagination -->
                        <b-pagination
                          v-model="month_currentPage"
                          :total-rows="month_count"
                          :per-page="month_perPage"
                          first-number
                          last-number
                        />
                      </ul>
                    </div>
                  </div>
                </div>
              </b-tab>
              <!-- <b-tab title="Buy" disabled> </b-tab>
                        <b-tab title="Sell" disabled> </b-tab> -->
            </b-tabs>
          </div>
        </div>
      </div>
    </div>


    <div  class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title mb-4">
              充提记录
            </h4>
              <!-- Table -->
              <div>
                <b-table
                  hover
                  :items="charge_list"
                  :fields="chargefields"
                />
              </div>
          </div>
        </div>
      </div>
    </div>

  </Layout>
</template>